import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import snack from '@/helpers/snack'

export default {
  GET_GOOD_FLOWS: ({ commit, state }, payload) => {
    if (payload.params.offset === 0) {
      commit('setGoodFlows', [])
    }

    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.all}`,
        {
          params: payload.params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('updateGoodFlows', data.items)
          commit('setFlowFilters', data.filters)
          commit('setCount', data.count)
        } else {
        }
        resolve()
      })
    })
  },
  GET_GOOD_FLOW: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.one.replace('$1', params.id)}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        // console.log('GET_GOOD_FLOW');
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setFlowType', data.type)
          delete data.type
          commit('setGoodFlow', data)
        }

        resolve()
      })
    })
  },
  UPDATE_GOOD_FLOW: ({ commit, state }, params) => {
    let requestParams = _.cloneDeep(state.goodFlow)
    const id = requestParams.id

    requestParams = _.omit(
      requestParams,
      'id',
      'sender',
      'sender_store',
      'sender_unit',
      'recipient',
      'recipient_store',
      'recipient_unit',
      'employer',
    )

    return new Promise((resolve, reject) => {
      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.one.replace('$1', id)}`,
        requestParams,
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            commit('setLoad', false)

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.savedMessage,
            })
          }

          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  CREATE_GOOD_FLOW: ({ commit, state }, params) => {
    let requestParams = _.cloneDeep(state.goodFlow)

    requestParams = _.omit(
      requestParams,
      'id',
      'sender',
      'sender_store',
      'sender_unit',
      'recipient',
      'recipient_store',
      'recipient_unit',
      'employer',
    )

    return new Promise((resolve, reject) => {
      request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.all}`, requestParams, true)
        .then(response => {
          if (response.data.result === 'success') {
            const data = response.data

            commit('setGoodFlowParam', { id: data.data.id })

            router.push({ path: Vue.config.modules.crm.route.goodFlows.one.replace('$1', data.data.id) })
            commit('setLoad', false)

            Vue.notify({
              group: 'hasBottomNavigation',
              title: '',
              type: 'success',
              text: Vue.config.localization.ru.savedMessage,
            })
          }

          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', true)
        })
    })
  },
  DELETE_GOOD_FLOW: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.one.replace('$1', payload.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          router.push({ path: Vue.config.modules.crm.route.goodFlows.all })

          snack.add(Vue.config.localization.ru.successRemove, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  RESTORE_GOOD_FLOW: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PATCH',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.one.replace('$1', payload.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('setGoodFlowParam', { deleted_at: null })

          snack.add(Vue.config.localization.ru.successRestore, 'primary')
          resolve()
        } else {
          snack.add(Vue.config.localization.ru.errorRestoreMessage)
        }
      })

      commit('setLoad', false)
    })
  },
  GET_FLOW_TYPES: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.type}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setFlowTypes', data.items)
        }

        resolve()
      })
    })
  },
  GET_FLOW_STATUSES: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.status}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setFlowStatuses', data.items)
        }

        resolve()
      })
    })
  },
  GET_FLOW_QTY_UNITS: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.qty}`,
        {
          params: params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setQtyUnits', data)
        }

        resolve()
      })
    })
  },
  GET_FLOW_ITEMS: ({ commit, state }, params) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlowItems.all}`,
        {
          params: params,
        },
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('setFlowItems', data.items)
            commit('setFlowItemsCount', data.count)
          }

          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', true)
        })
    })
  },
  SAVE_FLOW_ITEM: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlowItems.all}`,
        {
          with: 'good;qtyUnit',
          attr: payload,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('delFlowItem', data.id)
          commit('addFlowItem', data)

          const msg = Vue.config.localization.ru.goodInventGoodAdded
            .replace('$1', data.good.title)
            .replace('$2', data.qty)
          snack.add(msg, 'primary')

          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  DELETE_FLOW_ITEM: ({ commit, state, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlowItems.one.replace('$1', payload.id)}`,
        {},
        true,
      )
        .then(response => {
          commit('delFlowItem', payload.id)
          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')

          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_GOOD_BY_BARCODE({ commit, state }, barcode) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodFlows.barcode}`.replace('$1', barcode),
      {},
      true,
    )
  },

  GET_GOOD_FLOWS_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    return Promise.all([
      dispatch('GET_UNITS'),
      dispatch('GET_ALL_CONTRACTORS'),
      dispatch('GET_GOOD_FLOWS', payload),
      dispatch('GET_FLOW_TYPES'),
      dispatch('GET_FLOW_STATUSES'),
    ]).finally(() => {
      commit('setLoad', false)
    })
  },

  GET_GOOD_FLOW_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    return Promise.all([
      dispatch('GET_FLOW_TYPES'),
      dispatch('GET_FLOW_STATUSES'),
      dispatch('GET_FLOW_QTY_UNITS'),
      dispatch('GET_FLOW_ITEMS', {
        search: `good_flow_id:${payload.id}`,
        with: 'good;qtyUnit',
        orderBy: 'updated_at',
        sortedBy: 'desc',
        offset: payload.offset,
        limit: payload.limit,
      }),
      dispatch('GET_GOOD_FLOW', {
        id: payload.id,
        with: 'type;employer;sender;senderUnit;senderStore;recipient;recipientUnit;recipientStore',
      }),
    ]).finally(() => {
      commit('setLoad', false)
    })
  },

  GET_GOOD_FLOW_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    return Promise.all([
      dispatch('GET_FLOW_TYPES'),
      dispatch('GET_FLOW_STATUSES'),
      dispatch('GET_FLOW_QTY_UNITS'),
    ]).finally(() => {
      commit('setLoad', false)
    })
  },
}
